import { Injectable } from '@angular/core';
import { HttpStatusCode } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomMessageService } from 'library';
import { RequestService } from 'projects/store/src/app/services/api/v1/request.service';

export enum PhoneAppState {
  Ready = 'ready',
  Waiting = 'waiting'
}

@Injectable({
  providedIn: 'root'
})
export class PhoneAppStatusService {
  private stateSubject = new BehaviorSubject<PhoneAppState>(PhoneAppState.Waiting);
  state$: Observable<PhoneAppState> = this.stateSubject.asObservable();

  private pollingInterval: any;
  private requestId: string | null = null;

  constructor(
    private requestService: RequestService,
    private customMessageService: CustomMessageService
  ) {}

  start(requestId: string): void {
    this.stop();
    this.requestId = requestId;
    this.stateSubject.next(PhoneAppState.Waiting);
    this.loadAppInformation();
  }

  stop(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.requestId = null;
  }

  private loadAppInformation(): void {
    if (!this.requestId) return;

    this.requestService.getAppInformation(this.requestId).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.stateSubject.next(PhoneAppState.Ready);
        } else {
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: any) => {
        if (error.status === HttpStatusCode.NotAcceptable) {
          this.stateSubject.next(PhoneAppState.Waiting);
          this.startPolling();
        } else {
          this.customMessageService.responseNoticeHandler(error);
        }
      }
    });
  }

  private startPolling(): void {
    if (this.pollingInterval) return;

    this.pollingInterval = setInterval(() => {
      if (!this.requestId) return;

      this.requestService.getAppInformation(this.requestId).subscribe({
        next: (resp) => {
          if (resp.status === HttpStatusCode.Ok) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.stateSubject.next(PhoneAppState.Ready);
          }
        },
        error: (error: any) => {
          if (error.status === HttpStatusCode.NotAcceptable) {
            this.stateSubject.next(PhoneAppState.Waiting);
          } else {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.customMessageService.responseNoticeHandler(error);
          }
        }
      });
    }, 20000);
  }
}